import Historical from './Historical';

export default Historical;